<script setup>
import '@campact/camper/icons/CmprIconSolidLock';
</script>

<template>
  <div class="tls-notice">
    <cmpr-icon-solid-lock class="tls-notice__lock-icon" />
    <slot />
  </div>
</template>
